import { Adornment, CelebrationTypeEnum } from '@kudos/http-client'
import {
  celebrationIcon,
  celebrationIconColor,
} from '@shared/celebration/celebrationDisplayStyleUtils'
import { ReactElement } from 'react'

export const ADORNMENT_ICON: Record<Adornment, ReactElement> = {
  b: celebrationIcon[CelebrationTypeEnum.BIRTHDAY],
  a: celebrationIcon[CelebrationTypeEnum.ANNIVERSARY],
  w: celebrationIcon[CelebrationTypeEnum.WELCOME],
}

/** Badge fill uses saturated celebration icon colors (mockup), not ExtraLight backgrounds. */
export const ADORNMENT_BG_COLOR: Record<Adornment, string> = {
  b: celebrationIconColor[CelebrationTypeEnum.BIRTHDAY],
  a: celebrationIconColor[CelebrationTypeEnum.ANNIVERSARY],
  w: celebrationIconColor[CelebrationTypeEnum.WELCOME],
}

export type PreviewCelebrationType =
  | CelebrationTypeEnum.WELCOME
  | CelebrationTypeEnum.BIRTHDAY
  | CelebrationTypeEnum.ANNIVERSARY

export const PREVIEW_CELEBRATION_ADORNMENT: Record<PreviewCelebrationType, Adornment> = {
  [CelebrationTypeEnum.WELCOME]: 'w',
  [CelebrationTypeEnum.BIRTHDAY]: 'b',
  [CelebrationTypeEnum.ANNIVERSARY]: 'a',
}
